import { flowRight as compose } from 'lodash';
import { withErrorBoundary, withToastContext } from '../../hocs';
import GoogleSearch from './GooglePlacesSearch.component';

export default compose(withErrorBoundary(), withToastContext())(GoogleSearch);
